<template>
  <div id="our-serve">
    <div class="ourServe" id="serve">
      <p class="ourServe-line"></p>
      <p class="ourServe-title">
        {{ this.$t("lang.BetterMedicalCare.ourService") }}
      </p>
      <p class="ourServe-line"></p>
    </div>
    <div class="active">
      <router-link tag="a" target="_blank" to="/MemberCenter">
        <img :src="this.$t('lang.imgUrl.bmcOurServe')" alt="" />
      </router-link>
    </div>
    <div class="serve-icon">
      <el-row :gutter="20">
        <el-col :span="6" v-for="item of serveLists" :key="item.id"
          ><div class="icon-item">
            <p :class="item.iconfont + ' ' + item.icon"></p>
          </div>
          <div :class="languageItem">
            <h3 :class="languageTitle">
              {{ item.title }}
            </h3>
            <p :class="languageContent">
              {{ item.content }}
            </p>
          </div></el-col
        >
      </el-row>
    </div>
    <div class="reply">
      {{ this.$t("lang.BetterMedicalCare.sevenDays") }}
    </div>
    <div class="hospital">
      <div class="hospital-list" id="left">
        <a
          href="http://47.99.101.7:8080/pdf/优诊通（华夏版服务医院）.pdf"
          target="_blank"
        >
          <p style="line-height: 20px">{{ this.$t("lang.BetterMedicalCare.chineseHospital") }}</p>
        </a>
        <span class="iconfont">&#xe603;</span>
      </div>
      <div class="hospital-list" id="right">
        <a
          href="http://47.99.101.7:8080/pdf/优诊通（全球版服务医院）.pdf"
          target="_blank"
        >
          <p style="line-height: 20px">{{ this.$t("lang.BetterMedicalCare.globalHospital") }}</p>
        </a>
        <span class="iconfont">&#xe603;</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurServe",
  components: {},
  data() {
    return {
      languageItem: "",
      languageTitle: "",
      languageContent: "",
      serveList: [
        {
          id: 1,
          flag: false,
          iconfont: "iconfont",
          icon: "icon-yiyuan2",
          title: this.$t("lang.BetterMedicalCare.expertOutpatient"),
          content: this.$t("lang.BetterMedicalCare.expertOutpatientDetail")
        },
        {
          id: 2,
          flag: false,
          iconfont: "iconfont",
          icon: "icon-shoushu",
          title: this.$t("lang.BetterMedicalCare.expertOperation"),
          content: this.$t("lang.BetterMedicalCare.expertOperationDetail")
        },
        {
          id: 3,
          flag: false,
          iconfont: "iconfont",
          icon: "icon-menzhenanpai",
          title: this.$t("lang.BetterMedicalCare.expertWard"),
          content: this.$t("lang.BetterMedicalCare.expertWardDetail")
        },
        {
          id: 4,
          flag: false,
          iconfont: "iconfont",
          icon: "icon-zan",
          title: this.$t("lang.BetterMedicalCare.expertRecommendation"),
          content: this.$t("lang.BetterMedicalCare.expertRecommendationDetail")
        }
      ]
    };
  },
  mounted() {
    this.setStyle();
  },
  beforeUpdate() {
    this.setStyle();
  },
  methods: {
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.languageItem = "serve-item-us";
        this.languageTitle = "serve-item-title-us";
        this.languageContent = "serve-item-content-us";
      } else if (this.$i18n.locale === "zh-CN") {
        this.languageItem = "serve-item";
        this.languageTitle = "serve-item-title";
        this.languageContent = "serve-item-content";
      }
    }
  },
  computed: {
    serveLists() {
      return [
        {
          id: 1,
          flag: false,
          iconfont: "iconfont",
          icon: "icon-yiyuan2",
          title: this.$t("lang.BetterMedicalCare.expertOutpatient"),
          content: this.$t("lang.BetterMedicalCare.expertOutpatientDetail")
        },
        {
          id: 2,
          flag: false,
          iconfont: "iconfont",
          icon: "icon-shoushu",
          title: this.$t("lang.BetterMedicalCare.expertOperation"),
          content: this.$t("lang.BetterMedicalCare.expertOperationDetail")
        },
        {
          id: 3,
          flag: false,
          iconfont: "iconfont",
          icon: "icon-menzhenanpai",
          title: this.$t("lang.BetterMedicalCare.expertWard"),
          content: this.$t("lang.BetterMedicalCare.expertWardDetail")
        },
        {
          id: 4,
          flag: false,
          iconfont: "iconfont",
          icon: "icon-zan",
          title: this.$t("lang.BetterMedicalCare.expertRecommendation"),
          content: this.$t("lang.BetterMedicalCare.expertRecommendationDetail")
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#our-serve {
  width: 100%;
  .ourServe {
    margin: 70px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .ourServe-title {
      font-size: 20px;
      color: $publicBlue;
      margin: 0 22px;
    }
    .ourServe-line {
      flex: 1;
      border-bottom: 2px solid #cacaca;
    }
  }
  .active {
    width: 75%;
    margin: 0 auto;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  .serve-icon {
    width: 75%;
    margin: 88px auto 0 auto;
    .icon-item {
      margin: 0 auto;
      height: 122px;
      width: 122px;
      box-shadow: 0px 8px 37px 6px rgba(151, 203, 255, 0.18);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $publicBlue;
      p {
        font-size: 50px;
      }
    }
    .serve-item-us {
      margin: 38px auto;
      height: 362px;
      box-shadow: -2px 7px 19px 2px rgba(130, 195, 255, 0.14);
      border-radius: 10px;
      overflow: hidden;
      .serve-item-title {
        height: 50px;
        background: $publicBlue;
        color: $pureWhite;
        font-size: 22px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .serve-item-title-us {
        height: 50px;
        background: $publicBlue;
        color: $pureWhite;
        font-size: 16px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .serve-item-content {
        margin: 18px;
        color: #ababab;
        font-size: 14px;
        line-height: 24px;
        word-break: break-all;
      }
      .serve-item-content-us {
        margin: 10px 18px;
        color: #ababab;
        font-size: 12px;
        line-height: 16px;
        word-break: break-all;
      }
    }
    .serve-item {
      margin: 38px auto;
      height: 342px;
      box-shadow: -2px 7px 19px 2px rgba(130, 195, 255, 0.14);
      border-radius: 10px;
      overflow: hidden;
      .serve-item-title {
        height: 50px;
        background: $publicBlue;
        color: $pureWhite;
        font-size: 22px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .serve-item-title-us {
        height: 50px;
        background: $publicBlue;
        color: $pureWhite;
        font-size: 16px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .serve-item-content {
        margin: 18px;
        color: #ababab;
        font-size: 14px;
        line-height: 24px;
        word-break: break-all;
      }
      .serve-item-content-us {
        margin: 10px 18px;
        color: #ababab;
        font-size: 12px;
        line-height: 16px;
        word-break: break-all;
      }
    }
  }
  .reply {
    color: #b4b3b3;
    font-size: 14px;
    width: 75%;
    margin: 0 auto 40px auto;
  }
  .hospital {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    .hospital-list {
      display: flex;
      color: $publicBlue;
      p {
        width: 90px;
        font-size: 14px;
        text-align: center;
        color: $publicBlue;
      }
      span {
        color: $publicBlue;
      }
    }
  }
}
#left {
  margin-right: 150px;
}
</style>
